export default __webpack_public_path__ + "static/media/Photo 12 - BR - pergola.25b2f29d.jpg";